// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Iymo","importantInfo":"styles_importantInfo__1cOYV"};